import { HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { CloseIcon, CheckIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import ButtonOutline from 'UiKit/button/buttonOutline';
import { TextSemiBold } from 'UiKit/typography';
import usePatchRequestApproval from 'Domain/reschedule/usePatchRequestApproval';
import useConfirmationModal from 'View/reschedule/hooks/useConfirmationModal';

import styles from './styles.module.css';

const ActionButton = ({ values }) => {
  const { t } = useTranslation('reschedule');
  const { openAcceptConfirmation, openRejectConfirmation } = useConfirmationModal();
  const { mutate: patchRequestApproval } = usePatchRequestApproval();
  const navigate = useNavigate();
  const { statusProgress } = values;

  const accessPermission = getMenuPermissions('schedule', 'request-approval');

  const onClickDetail = () => navigate(`/schedule/approval-reschedule/${values?.id}`);
  const onClickApprove = () => openAcceptConfirmation(() => patchRequestApproval({ id: values?.id, statusProgress: 'Diterima' }));
  const onClickReject = () => openRejectConfirmation(() => patchRequestApproval({ id: values?.id, statusProgress: 'Ditolak' }));

  return (
    <HStack spacing={2}>
      <Condition statement={statusProgress === 'Diproses' && accessPermission?.isCanEdit}>
        <ButtonOutline
          size="sm"
          color="var(--color-error50)"
          borderWidth="1.5px"
          className={`${styles['icon-button']} ${styles['icon-button--reject']}`}
          onClick={onClickReject}
          data-testid="reschedule-action__button--reject"
        >
          <CloseIcon color="var(--color-error50)" size={16} />
        </ButtonOutline>

        <ButtonOutline
          size="sm"
          color="var(--color-success60)"
          borderWidth="1.5px"
          className={`${styles['icon-button']} ${styles['icon-button--approve']}`}
          onClick={onClickApprove}
          data-testid="reschedule-action__button--approve"
        >
          <CheckIcon color="var(--color-success60)" size={16} />
        </ButtonOutline>
      </Condition>

      <ButtonOutline size="sm" borderWidth="1.5px" className={styles['detail-button']} onClick={onClickDetail}>
        <TextSemiBold className={styles['detail-button__text']}>{t('detailButton')}</TextSemiBold>
      </ButtonOutline>
    </HStack>
  );
};

export default ActionButton;
